/**
 * @module ResizeTracker
 */
class ResizeTracker {

    /**
     * Class constructor
     */
    constructor() {
        this._isTicking = false;
        this._onResize = this._onResize.bind(this);
        this._currentSize = {
            width: 0,
            height: 0
        };
    }

    /**
     * Handle on resize event
     * @private
     * @param {event} event
     */
    _onResize() {
        if (!this._isTicking) {
            const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            // eslint-disable-next-line curly
            if (width === this._currentSize.width && height === this._currentSize.height) return;

            window.requestAnimationFrame(() => {
                this._currentSize.width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                this._currentSize.height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
                this._cb(window.innerWidth);

                this._isTicking = false;
            });
        }

        this._isTicking = true;
    }

    /**
     * @public
     */
    unload() {
        window.removeEventListener('resize', this._onResize);
    }

    /**
     * Bind event listeners
     * @private
     */
    _addEventListeners() {
        window.addEventListener('resize', this._onResize);
    }

    /**
     * Initialize
     * @param {Object} options - ConditionerJS's merged options
     * @param {Object} cb -
     */
    init(options, cb) {
        this._options = options;
        this._cb = cb;
        this._currentSize.width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        this._currentSize.height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        this._addEventListeners();
    }
}

export default ResizeTracker;
